export default "__VITE_ASSET__5wiXU5r5__"